<template>
  <div class="vx-col w-full">
    <!--  md:w-1/2 lg:w-1/2 xl:w-1/2 md:mt-0 mb-6 -->
    <div>
      <!-- <b-button :target="item.target" :href="item.href"
        >Toggle Sidebar</b-button
      > -->
      <handle-question-sidebar
        :availableCategories="availableCategories"
        :question="selectedQuestion"
        @update:question="updateQuestion"
        @delete:question="deleteQuestion"
        :active="isQuestionHandlerSidebarOpen"
        @update:active="isQuestionHandlerSidebarOpen = $event"
        :isEditable="isEditable"
      />
    </div>

    <!-- Header -->
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <!-- ACTION - DROPDOWN -->

      <!-- New area -->

      <vs-dropdown class="cursor-pointer flex" :vs-trigger-click="true" vs-custom-content>
        <div
          v-if="availableAreas.length > 0 && isEditable"
          class="
            btn-add-new
            p-3
            mb-4
            mr-4
            rounded-lg
            cursor-pointer
            flex
            items-center
            justify-center
            text-lg
            font-medium
            text-base text-primary
            border border-solid border-primary
          "
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">New area</span>
        </div>

        <vs-dropdown-menu style="z-index: 200001">
          <vs-dropdown-item
            :disabled="containsArea(area)"
            @click.stop="addArea(area)"
            class="px-0 py-2"
            v-for="(area, index) in availableAreas"
            :key="index"
          >
            <feather-icon
              icon="MapPinIcon"
              class="p-2 inline-flex rounded-lg bg-white border border-solid border-grey shadow"
              svgClasses="h-5 w-5"
            />
            <span class="ml-3">{{ area }}</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

      <!-- New area end -->
    </div>

    <!-- Header end -->

    <draggable
      tag="ul"
      :disabled="!isEditable"
      group="all-areas"
      class="draggable-list"
      ghost-class="moving-card"
      filter=".action-button"
      :list="list.questionAreas"
      :animation="200"
    >
      <vx-card
        class="mb-5"
        v-for="questionArea in list.questionAreas"
        :key="questionArea.area"
        :title="isVenueArea(questionArea.area) ? questionArea.area : noneVenueAreaName"
        @remove="removeArea(questionArea.area)"
        collapse-action
        :remove-card-action="isVenueArea(questionArea.area)"
        style="transition: 0.5s ease-out"
        @refresh="closeCardAnimationDemo"
      >
        <p v-if="isVenueArea(questionArea.area)" class="mb-2 text-dark-grey">
          This is a
          <code><feather-icon icon="HomeIcon" svgClasses="h-5 w-5" class="align-middle" /> venue area</code>.
          Questions here will be shown for each {{ questionArea.area }}(s).
        </p>
        <!-- start -->
        <div class="px-3 mt-4">
          <!-- max-w-md -->
          <draggable
            :disabled="!isEditable"
            tag="ul"
            group="all-questions"
            class="draggable-list"
            ghost-class="moving-card"
            :class="{
              'empty-draggable-area': questionArea.questions.length === 0,
            }"
            filter=".action-button"
            :list="questionArea.questions"
            :animation="200"
          >
            <question-template-card
              v-for="(question, qIdx) in questionArea.questions"
              :question="question"
              :key="qIdx"
              @on-edit="onEdit"
            />
          </draggable>

          <!-- Add new start -->
          <vs-dropdown
            v-if="isEditable"
            class="cursor-pointer flex"
            :vs-trigger-click="true"
            vs-custom-content
          >
            <div class="cursor-pointer">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">New question</span>
            </div>

            <vs-dropdown-menu style="z-index: 200001">
              <vs-dropdown-item
                @click.stop="addQuestion(iconKey, questionArea.area)"
                class="px-0 py-2"
                v-for="(iconKey, index) in Object.keys(iconMap)"
                :key="index"
              >
                <feather-icon
                  :icon="iconMap[iconKey].icon"
                  class="p-2 inline-flex rounded-lg bg-white border border-solid border-grey shadow"
                  svgClasses="h-5 w-5"
                />
                <span class="ml-3">{{ iconMap[iconKey].name }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- Add new end -->
        </div>
        <!-- end -->
      </vx-card>
    </draggable>
    <!-- Save & Remove Button -->
    <vs-row vs-justify="space-between" class="flex flex-wrap items-center" style="margin-top: 32px">
      <vs-button v-if="isEditable" @click="$emit('update:list')">Save</vs-button>
      <!-- <vs-button color="danger" @click="$emit('publish')">Publish</vs-button> -->
    </vs-row>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import QuestionTemplateCard from "./QuestionTemplateCard.vue";
import HandleQuestionSidebar from "./HandleQuestionSidebar.vue";
import { mapGetters } from "vuex";
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap/dist/css/bootstrap.css'

export default {
  components: {
    Draggable,
    QuestionTemplateCard,
    HandleQuestionSidebar,
  },
  data() {
    return {
      noneVenueAreaName: "All areas",
      selectedQuestion: null,
      isQuestionHandlerSidebarOpen: false,
    };
  },
  props: {
    availableCategories: {
      type: [],
      default: () => [],
    },
    availableAreas: {
      type: [],
      default: () => [],
    },
    list: {
      type: Object,
      default: () => ({}),
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isNewestVersion: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      iconMap: "lists/iconMap",
    }),
    containsArea() {
      return area => {
        return this.list.questionAreas.some(questionArea => questionArea.area === area);
      };
    },
    isVenueArea() {
      return name => name !== "None";
    },
  },
  methods: {
    async addArea(area) {
      this.list.questionAreas.push({
        area: area,
        areaSession: null,
        questions: [],
      });
    },
    async addQuestion(type, area) {
      //this.$emit("add-question", type, area);
      console.log("addQuestion", type, area);
      const newQuestion = await this.$store.dispatch("lists/createQuestion", type);

      this.list.questionAreas.find(questionArea => {
        if (questionArea.area === area) {
          questionArea.questions.push(newQuestion);
          return true;
        }
        return false;
      });

      this.handleQuestionClick(newQuestion);
    },
    handleQuestionClick(question) {
      this.selectedQuestion = JSON.parse(JSON.stringify(question));
      this.isQuestionHandlerSidebarOpen = true;
    },
    updateQuestion() {
      this.list.questionAreas.map(a => {
        a.questions.map(q => {
          if (q.id === this.selectedQuestion.id) {
            q.category = this.selectedQuestion.category;
            q.title = this.selectedQuestion.title;
            q.helpText = this.selectedQuestion.helpText;
            q.type = this.selectedQuestion.type;
            q.requireCommentWhenLowScore = this.selectedQuestion.requireCommentWhenLowScore;
            q.commentRequiredWhenScoreAtOrBelow = this.selectedQuestion.commentRequiredWhenScoreAtOrBelow;
            q.isAnswerRequired = this.selectedQuestion.isAnswerRequired;
          }
        });
      });

      this.selectedQuestion = null;
    },
    deleteQuestion() {
      this.list.questionAreas.forEach(questionArea => {
        questionArea.questions = questionArea.questions.filter(
          question => question.id !== this.selectedQuestion.id,
        );
      });
      this.selectedQuestion = null;
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
    },
    removeArea(area) {
      setTimeout(() => {
        this.list.questionAreas = this.list.questionAreas.filter(questionArea => questionArea.area !== area);
      }, 1500);
    },
    onEdit(question) {
      this.handleQuestionClick(question);
    },
  },
  async mounted() {},
};
</script>



<style>
#sidebar-right {
  background-color: #fff;
}

.header-dark {
  background-color: #f6f6f6;
}

.draggable-list {
  min-height: 100px;
}
/* Unfortunately @apply cannot be setup in codesandbox, 
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px dashed #4299e1;
}

.empty-draggable-area {
  background: #f7fafc;
  border: 1px dashed #4299e186;
  border-radius: 8px;
  height: 64px !important;
  max-height: 64px !important;
  min-height: 64px !important;
  margin-bottom: 15px;
}
</style>
